<template>
  <div class="w-full flex bg-white my-2 px-6 py-10 height-100 border-round">
    <div class="flex justify-center w-full items-center">
      <div class="flex gap-3 items-center">
        <div class="">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="new-height"
          />
        </div>
        <div class="text-left pl-4">
          <h1 class="fsize21 text-dark font-semibold">
            Hello there!<br />
            Welcome to BR<span class="col-ffc1">AI</span>NED
          </h1>
          <p class="fsize14 text-gray mb-0">
            Before we move to the dashboard let us get your<br />
            one-time business profile setup completed
          </p>
          <vs-button
            type="primary"
            @click="handleClick('profile-v')"
            class="rounded-full bg-primary border-0 mt-4 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 px-12 sm-fsize14"
          >
            Lets Go
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      completed: false,
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    IScompleted() {
      if (this.completed === true) {
        this.$router.push({ name: "dashboard" });
      }
    },
  },
  computed: {
    ...mapState("user", {
      brainedUserDetails: "brainedUserDetails",
      selectedProject: "selectedProject",
    }),
    ...mapState("brandProfile", {
      brandProfile: "brandProfile",
    }),
  },
  async mounted() {
    let payloadBrand = {
      projectId: this.selectedProject._id,
      projectName: this.selectedProject.projectName,
    };
    await this.$store.dispatch("brandProfile/getBrandProfile", payloadBrand);
    this.completed = this.brandProfile.isCompleted;
    this.IScompleted();
  },
};
</script>
